import { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { tileIcon } from '$components/Advantages';
import Container from '$components/layout/Container';
import { AppContext } from '$util/AppContext';
import { PreloadImage } from '$util/PreloadImage';
import { nutHeaderSrc } from '$layout/partials/TopBackground';
import PcLookup from '$commons/PcLookup';
import { TopTitle } from '../VrmLookupSection/components/TopTitle';
import Bottom from './bottom';
import Styled, { SubTitle } from './styled';

export default function PcLookupSection({ className, ...props }) {
  const { pathname, pageType, pageTypeFromPath } = useContext(AppContext);
  return (
    <>
      <PreloadImage provider="cloudinary" href={nutHeaderSrc} displayFrom="lg" />
      <Styled className={classNames('PcLookupSection', className)} {...props}>
        <Container>
          <div className="top-wrapper">
            <TopTitle pathname={pathname} pageTypeFromPath={pageTypeFromPath} />
            <SubTitle className="subtitle">
              We&#39;ve <b>handpicked over 400 local garages,</b>
              <br /> find one nearby for the best value car maintenance.
            </SubTitle>
            <PcLookup className="vrm-lookup" pageType={pageType} uniqId="VRMSection" />
          </div>
          <>
            <PreloadImage provider="cloudinary" src={tileIcon.pin} width={56} />
            <PreloadImage provider="cloudinary" src={tileIcon.wrench} width={56} />
            <PreloadImage provider="cloudinary" src={tileIcon.quote} width={56} displayFrom="lg" />
            <PreloadImage provider="cloudinary" src={tileIcon.shield} width={56} displayFrom="lg" />
            <Bottom pageType={pageType} pageTypeFromPath={pageTypeFromPath} />
          </>
        </Container>
      </Styled>
    </>
  );
}

PcLookupSection.propTypes = {
  className: PropTypes.string,
};

PcLookupSection.defaultProps = {
  className: '',
};
